export default "__VITE_ASSET__DrEdRTEl__"